<!--
 * @Description:任务过期列表弹层
 * @Date: 2024-04-29 14:15:47
-->
<template>
  <el-dialog
    center
    title="任务过期"
    :visible="true"
    :before-close="() => $emit('close')"
    top="7vh"
    width="1500px"
  >
    <base-table-form
      ref="baseForm"
      @input="form => (tableForm = form)"
      v-loading="tableLoading"
      :columns="tableSearchItems"
      @search="tableSearch({ isSelected: '0' })"
    ></base-table-form>
    <div class="task-list__actions">
      <task-batch-action-overdue style="padding-bottom: 16px" />
    </div>
    <base-table
      ref="baseTableRef"
      :tableColumn="tableColumn"
      :data="tableData"
      :highLightItem="highLightItem"
      v-loading="tableLoading"
      @select-all="selectCurrentPageAll"
      @sort-change="handleSortChange"
      :defaultSort="defaultSortQuery"
    />
    <el-row type="flex" justify="center">
      <base-table-page
        v-model="tablePageQuery"
        :total="tableTotal"
        :page-sizes="[15, 60, 100]"
        :disabled="tableLoading"
        @change="
          pagination => {
            tableSearch(pagination, 'pagination');
          }
        "
      />
    </el-row>
  </el-dialog>
</template>

<script>
import createExtend from '@C/createExtend';

import baseTable from '@R/components/Base/baseTable';
import request from '@/tools/request';
import taskBatchActionOverdue from '@R/components/task-batch-action-overdue';
import taskOverdueMsg from '@/page/project-record/components/task-overdue-msg.vue';

import { mapActions, mapState, mapMutations } from 'vuex';
import { auditStatusMapping } from '@R/static/mapping';
import { moneyFixed } from '@/tools/money.js';

import setDefaultQuery from '@R/services/set-overdue-default-query';
import BaseTableForm from '@R/components/Base/tableForm';
import BaseTablePage from '@R/components/Base/tablePage';
import BaseTableMixin from '@R/components/Base/tableMixins';

import { auditTaskOverdueListOne } from '@R/api';

const MAX_SELECTED = 2000; // 最大勾选值
const setDefaultSort = defaultSort => {
  window.sessionStorage.setItem(
    'defaultSortOverdue',
    JSON.stringify(defaultSort)
  );
};

const getDefaultSort = () => {
  const defaultSort = window.sessionStorage.getItem('defaultSortOverdue');
  if (defaultSort) return JSON.parse(defaultSort);

  return {};
};
export default {
  name: 'taskOverdue', //任务审核记录
  props: ['isOpenedByOther', 'otherQuery'],
  mixins: [BaseTableMixin],
  components: {
    BaseTablePage,
    BaseTableForm,
    // baseForm,
    baseTable,
    // basePagination,
    taskBatchActionOverdue
  },
  data() {
    return {
      tableLoading: false,
      tableSearchItems: [],
      tableColumn: [],
      highLightItem: '' //点过查看的项
    };
  },
  computed: {
    ...mapState('dataAnalysis', ['projectDetail']),
    ...mapState('dataAnalysis/taskOverdue', [
      'isAll',
      'selectedSize',
      'tableDataRespondQuery'
    ]),
    homeProject() {
      return this.$store.state.homeProject;
    },
    projectType() {
      return this.projectDetail.projectType || +this.$route.query.projectType;
    },
    hiddenDownload() {
      return [1, 2, 3, 7, 8, 9, 10].includes(this.projectType);
    },
    showExcessAudit() {
      return [5, 17, 20].includes(this.projectType);
    },
    showTaskRevoke() {
      return !this.homeProject.fileUpMode !== 1 && this.projectType !== 21;
    },
    ids() {
      return (this.tableData || [])
        .map(item => {
          return item.taskId;
        })
        .join(',');
    },
    defaultSortQuery() {
      return {
        prop: getDefaultSort().prop,
        order: getDefaultSort().order
      };
    }
  },
  watch: {
    selectedSize() {
      this.setHeaderCheckBoxStatus();
    },
    tableData() {
      this.setHeaderCheckBoxStatus();
    },
    'projectDetail.projectId': {
      immediate: true,
      async handler(v) {
        // 列表初始化或者更改了项目
        if (v) {
          this.tableData = [];
          await this.createTable(); // 设置 columns
          this.$refs.baseTableRef.columnsDone(); // columns初始化后
          const params = await this.initDefaultQuery(); // 初始化 参数
          const fortterParams = {};
          // 后端不支持空字段
          Object.keys(params).forEach(pKey => {
            if (params[pKey] !== '') {
              fortterParams[pKey] = params[pKey];
            }
          });
          await this.tableSearch({ ...fortterParams, isSelected: 0 });
        }
      }
    }
  },
  methods: {
    ...mapMutations('dataAnalysis/taskOverdue', ['CLEAR_QUERY_COUNT_TIMER']),
    // 设置当页全选状态
    setHeaderCheckBoxStatus() {
      this.$nextTick(() => {
        // 需要在checkBox组件之后执行
        setTimeout(() => {
          const checkBox = document.querySelector(
            '.el-table__header .el-checkbox__original'
          );
          const parentClassName = checkBox.parentNode.className;
          // 如果当页没有勾选数据，则禁用。根据class判断，防止下一页溢出可进行当页全选
          const isCurrentChecked = ~parentClassName.indexOf('is-checked');
          // >= 2000 && 没有勾选数据，则禁止操作。否则表示当页已全部勾选或者小于2000
          if (
            this.selectedSize + this.tableData.length > MAX_SELECTED &&
            !isCurrentChecked
          ) {
            if (!~parentClassName.indexOf('is-disabled')) {
              checkBox.parentNode.className = parentClassName + ' is-disabled';
              checkBox.disabled = 'disabled';
            }
          } else {
            checkBox.parentNode.className = parentClassName.replace(
              'is-disabled',
              ''
            );
            checkBox.disabled = '';
          }
        });
      });
    },
    /**
     * @description: 搜索，分页
     * @param {object} param 接口参数
     * @param {string} type 区分是否需要初始化列表。 init初始分页（如搜索），pagination 分页标识。
     */
    tableSearch(param, type = 'init') {
      let q = null;
      if (type === 'init') {
        q = { ...this.tableSearchQuery };
      }
      if (type === 'pagination') {
        //表格响应数据的 query 全选多选用到

        // 切换 分页要保持相同请求参数 搜索表单的值 要与实际请求数据结果的入参一致
        const { form } = this.$refs.baseForm;
        Object.keys(form).forEach(k => {
          form[k] = this.tableDataRespondQuery[k];
        });

        q = { ...this.tableDataRespondQuery };
      }

      // 混合以组件调用时传入的参数
      Object.assign(q, {
        ...(this.otherQuery &&
          this.otherQuery.statementId && {
            statementId: this.otherQuery.statementId
          })
      });
      if (param) {
        Object.assign(q, param);
      }
      if (this.projectType === 6) {
        Object.assign(q, {
          dataState: 0
        });
      }
      // 处理点击搜索后没有重置分页
      // this.tablePageQuery.pageNo !== 1 防止tablePage组件再次emit导致两次调用
      // param判断为了防止pageNo改为1。场景：详情操作后需刷新当前页数据时。
      if (type === 'init' && this.tablePageQuery.pageNo !== 1 && param) {
        this.tablePageQuery.pageNo = 1;
        this.tablePageQuery.isSelected = 0; // isSelected 仅在搜索时为0，后续都为1
        return;
      }

      // 排序字段处理
      const sortVal = getDefaultSort();
      if (Object.keys(sortVal).length > 0) {
        const sortOrder = {
          [sortVal.prop + 'Order']: sortVal.order
        };
        Object.assign(q, sortOrder);
      }

      this.tableLoading = true;
      this.getList(q)
        .then(res => {
          const { list, total } = res;
          this.tableData = JSON.parse(JSON.stringify(list));
          this.tableTotal = total;
          return res;
        })
        .then(({ query }) => {
          // 用户标签 字符串形式
          if (query.userTag && Array.isArray(query.userTag)) {
            if (query.userTag.includes('未设置')) {
              query.notSet = 1;
            }
            query.userTag = query.userTag.join(',');
          }
        })
        .finally(() => {
          this.tableLoading = false;
          this.tablePageQuery.isSelected = 1;
        });
    },
    ...mapActions('dataAnalysis/taskOverdue', ['getList']),
    /**
     *
     * @param isSelected 是否选中数据 1是 0否
     * @returns {Promise<void>}
     */
    async selectCurrentPageAll(isSelected) {
      const taskIds = this.tableData.map(i => i.taskId);
      if (taskIds.length < 1) {
        this.$notify({
          title: '失败',
          message: '暂无可操作数据！',
          type: 'error'
        });
        return;
      }

      const params = {
        isDelete: isSelected ? '0' : '1', //0新增 1 取消
        taskIds: taskIds,
        projectId: this.projectDetail.projectId
      };

      await request
        .post(' /rest/cso/saas/taskOverdue/taskRecordListAll/edit', params, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          notUseQs: true
        })
        .then(res => {
          this.$store.commit(
            'dataAnalysis/taskOverdue/SET_SELECTED_SIZE',
            res.data.data.selectedSize
          );
        });
      const q = {
        ...this.tableDataRespondQuery,
        isSelected: '1'
      };
      this.getList(q)
        .then(res => {
          const { list, total } = res;
          this.tableData = list;
          this.tableTotal = total;
          const q1 = JSON.parse(JSON.stringify(q));
          if (q1.userTag && typeof q1.userTag === 'string') {
            q1.userTag = q1.userTag.split(',');
          }
          setTimeout(() => {
            for (const k in q1) {
              this.$refs.baseForm.form[k] = q1[k];
            }
          });
          return res;
        })
        .then(({ query }) => {
          // 用户标签 字符串形式
          if (query.userTag && Array.isArray(query.userTag)) {
            if (query.userTag.includes('未设置')) {
              query.notSet = 1;
            }
            query.userTag = query.userTag.join(',');
          }
        });
    },
    // 其他页面进入无搜索，操作只有查看详情
    createTable() {
      return new Promise(resolve => {
        const vm = this;
        const { projectType, fileUpMode, fileUpSource } = this.homeProject;
        //协定服务活动形式的
        const showActivity =
          +projectType === 19 && (+fileUpMode === 1 || fileUpSource === 3);
        // 数字拜访
        const isDigitalVisit = +projectType === 17;
        let tableSearchItems = [
          {
            type: 'daterange',
            fieldKeys: ['finishDtStart', 'finishDtEnd'],
            hidden: this.projectType === 6,
            label: '', //提交时间
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '提交开始时间',
            'end-placeholder': '提交结束时间',
            pickerOptions: {
              shortcuts: [
                {
                  text: '本月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date(end.getFullYear(), end.getMonth());
                    picker.$emit('pick', [start, end]);
                  }
                }
              ],
              disabledDate(date) {
                return date >= new Date();
              }
            }
          },
          {
            type: 'daterange',
            fieldKeys: ['visitDtStart', 'visitDtEnd'],
            hidden: !+vm.projectDetail.showVisitDt,
            label: '', //拜访时间
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '拜访开始时间',
            'end-placeholder': '拜访结束时间',
            pickerOptions: {
              shortcuts: [
                {
                  text: '本月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date(end.getFullYear(), end.getMonth());
                    picker.$emit('pick', [start, end]);
                  }
                }
              ],
              disabledDate(date) {
                return date >= new Date();
              }
            }
          },
          {
            type: 'input',
            label: '', //项目参与人
            fieldKey: 'userName',
            placeholder: '项目参与人'
          },
          {
            type: 'input',
            label: '', //个体名
            fieldKey: 'userEnterpriseName',
            placeholder: '个体名',
            hidden: this.projectDetail.projectStructureType !== 2
          },
          {
            type: 'input',
            label: '', //手机号
            fieldKey: 'phone',
            placeholder: '手机号'
          },
          {
            width: '600px',
            placeholder: '人员标签',
            fieldKey: 'userTag',
            type: 'autocomplete',
            maxLength: 30,
            hidden: +this.homeProject.fileUpMode === 1, //有活动不展示
            querySearch: (queryString, cb) => {
              cb(
                [{ value: '未设置' }].filter(
                  i => i.value.indexOf(queryString) > -1
                )
              );
            }
          },
          {
            type: 'input',
            label: '', //任务编码
            hidden: this.projectType === 6,
            fieldKey: 'taskCode',
            placeholder: '任务编码'
          }
        ];
        if (!this.isOpenedByOther) {
          Array.prototype.push.apply(tableSearchItems, [
            {
              type: 'select',
              label: '', //服务商状态
              hidden: this.projectType === 6,
              placeholder: '服务商状态',
              fieldKey: 'auditStatus',
              options: [
                { label: '未提交审核', value: '0' },
                { label: '审核中', value: '1' },
                { label: '审核通过', value: '2' },
                { label: '审核未通过', value: '3' }
                // { label: '审核中', value: 5 }
              ]
            },
            {
              type: 'select',
              label: '', //平台状态
              hidden: this.projectType === 6,
              placeholder: '平台状态',
              fieldKey: 'auditOssStatus',
              options: [
                { label: '未提交审核', value: '0' },
                { label: '审核中', value: '1' },
                { label: '审核通过', value: '2' },
                { label: '审核未通过', value: '3' }
              ]
            }
          ]);
        }
        this.tableSearchItems = tableSearchItems;
        // 如果是园区
        this.tableColumn = [
          {
            prop: 'taskId',
            type: 'selection',
            resizable: false,
            width: '60px',
            fixed: 'left',
            hidden: !!this.isOpenedByOther,
            inputChange: function(v, row) {
              const { taskId } = row;
              //调 单个打对勾接口
              return new Promise((resolve, reject) => {
                request
                  .post(
                    ' /rest/cso/saas/taskOverdue/taskRecordListAll/edit',
                    {
                      projectId: vm.projectDetail.projectId,
                      taskIds: [taskId],
                      isDelete: v ? '0' : '1' // 0表示需要新增，1表示删除
                    },
                    {
                      headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                      },
                      notUseQs: true
                    }
                  )
                  .then(res => {
                    const {
                      data: {
                        code,
                        data: { selectedSize }
                      }
                    } = res;
                    if (+code === 1) {
                      vm.$store.commit(
                        'dataAnalysis/taskOverdue/SET_SELECTED_SIZE',
                        selectedSize
                      );
                      row.isSelected = v ? '1' : '0';
                      return resolve();
                    } else {
                      return reject();
                    }
                  });
              });
            },
            disabled: function(row) {
              return vm.selectedSize >= MAX_SELECTED && row.isSelected == '0';
            }
          },
          {
            type: 'index',
            label: '序号',
            width: '65px',
            resizable: false,
            fixed: 'left',
            render: (h, { scope }) => {
              return (
                <div>
                  <span>{scope.$index + 1}</span>
                </div>
              );
            }
          },
          {
            prop: 'userName',
            resizable: false,
            label: function() {
              return '项目参与人';
            },
            width: '150'
          }, // : "张三",//项目参与人
          {
            prop: 'userEnterpriseName',
            label: '个体',
            resizable: false,
            hidden: vm.projectDetail.projectStructureType !== 2
          }, // : "" , //个体
          { prop: 'phone', resizable: false, label: '手机号' },
          {
            prop: 'userTag',
            resizable: false,
            label: '人员标签',
            hidden: +fileUpMode === 1, //有活动不展示
            render(h, { row }) {
              return <span>{row['userTag'] || '未设置'}</span>;
            }
          },
          {
            prop: 'industryEnterpriseName',
            label: '客户企业',
            resizable: false,
            hidden: vm.projectType !== 6
          },
          {
            prop: 'passUv',
            resizable: false,
            label: '点击数(UV)',
            hidden: vm.projectType !== 6
          },
          // {
          //   prop: 'passUv',
          //   resizable: false,
          //   label: '过期任务量',
          //   hidden: vm.projectType !== 6
          // },
          {
            prop: 'csoPrice',
            resizable: false,
            label: '终端结算单价',
            width: '150',
            hidden: vm.projectType !== 6,
            formatter: ({ val }) => moneyFixed(val)
          },
          {
            prop: 'activityName',
            resizable: false,
            label: '关联活动',
            hidden: !showActivity,
            render(h, { row }) {
              return <span>{row.activityName || '-'}</span>;
            }
          },
          {
            prop: 'taskPrice',
            resizable: false,
            label: '任务单价',
            hidden: vm.projectType !== 19,
            formatter: ({ val }) => moneyFixed(val)
          },
          {
            prop: 'taskId',
            resizable: false,
            label: '审核进度',
            hidden: [6, 19].includes(vm.projectType), // 数字专区，协定服务没有该项
            render: function(h, { row }) {
              return h(
                'div',
                {
                  style: {
                    color:
                      row.passTaskSum >= row.residueTaskSum ? 'red' : '#67c23a'
                  }
                },
                `${row.passTaskSum || 0}/${row.residueTaskSum || 0}`
              );
            }
          },
          {
            prop: 'taskCode',
            resizable: false,
            hidden: vm.projectType === 6,
            label: '任务编码'
          }, // : "xxxxxxxxxx" , //任务编码
          {
            prop: 'finishDt',
            resizable: false,
            hidden: vm.projectType === 6,
            label: '提交时间',
            type: 'sortable',
            width: '150px',
            sortable: 'custom'
          }, // : "2021-09-11" , //提交时间
          {
            prop: 'visitDt',
            resizable: false,
            hidden: !+vm.projectDetail.showVisitDt,
            label: '拜访时间',
            type: 'sortable',
            width: '150px',
            sortable: 'custom',
            formatter: ({ row }) => {
              // 数字拜访特殊处理
              if (isDigitalVisit) {
                return row.visitDt;
              } else {
                if (row.visitDtStart && row.visitDtEnd) {
                  return row.visitDtStart + ' ~ ' + row.visitDtEnd;
                } else {
                  return '-';
                }
              }
            }
          }, // : "2021-09-11" , //拜访时间 数字拜访和可配置展示
          {
            prop: 'auditStatus',
            resizable: false,
            label: '服务商状态',
            width: '150',
            hidden: vm.projectType === 6,
            formatter: ({ val }) => {
              return auditStatusMapping[val];
            }
          }, //ASP审核状态 0 未提交审核  1审核中 2审核通过 3审核未通过  5 审核中（重新提交）
          {
            prop: 'csoAuditUser',
            resizable: false,
            label: '服务商审核人',
            width: '150',
            hidden:
              !vm.homeProject.isAuditCso || // 宏宏判断了其他场景 0是不展示 1展示
              (+vm.projectType === 19 && // 协定服务
                vm.homeProject.fileUpSource === 1), // 1ASP上传
            formatter: ({ val }) => {
              return val || '-';
            }
          },
          {
            prop: 'auditOssStatus',
            resizable: false,
            hidden: vm.projectType === 6,
            label: '平台状态',
            formatter: ({ val }) => {
              return auditStatusMapping[val];
            }
          }, // OSS审核状态 0 未提交审核  1审核中 2审核通过 3审核未通过
          {
            prop: 'auditGongyeStatus',
            resizable: false,
            hidden:
              vm.projectType === 6 ||
              !vm.projectDetail.industryEnterpriseId ||
              vm.projectDetail.industryEnterpriseId == -1,
            label: '工业状态',
            formatter: ({ val }) => {
              return auditStatusMapping[val];
            }
          }, //工业审核状态 0 未提交审核  1审核中 2审核通过 3审核未通过
          {
            prop: 'isOverdue',
            resizable: false,
            label: '是否过期',
            hidden: vm.projectType === 6,
            formatter: ({ val }) => {
              return ['未过期', '已过期'][val];
            }
          }, // : 0, //是否过期  0 未过期(默认)  1 已过期
          {
            prop: 'dataState',
            resizable: false,
            label: '结算状态',
            hidden: vm.projectType === 6,
            formatter: ({ val }) => {
              return ['未结算', '结算中', '已结算'][val];
            }
          }, // : 1 ,//结算状态  0未结算 1结算中 2已结算
          {
            label: '操作',
            resizable: false,
            fixed: 'right',
            render: function(h, { row }) {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      size: 'mini'
                    },
                    on: {
                      click: function() {
                        let content =
                          '<p>你正在操作任务过期，请谨慎处理，任务过期后将无法恢复</p>';
                        if (+vm.projectType === 6) {
                          content = '';
                        }
                        const overdueDialog = createExtend(taskOverdueMsg, {
                          content,
                          projectType: vm.projectType,
                          projectId: vm.projectDetail.projectId,
                          source: 2,
                          taskId: row.taskId
                        });
                        overdueDialog.$on('confirm', async redisKeyUv => {
                          await auditTaskOverdueListOne({
                            projectId: vm.projectDetail.projectId,
                            taskId: row.taskId,
                            redisKeyUv //专区查条数后端清缓存用的key
                          });
                          vm.tableSearch({ isSelected: '0' });
                          overdueDialog.remove();
                          vm.$message({
                            type: 'success',
                            message: '操作成功'
                          });
                        });
                      }
                    }
                  },
                  '任务过期'
                )
              ]);
            }
          }
        ];

        this.createTableId = setTimeout(resolve());
      });
    },
    initDefaultQuery() {
      return new Promise(resolve => {
        const { form } = this.$refs.baseForm;
        let defaultQuery = setDefaultQuery(
          this.otherQuery || this.$route.query
        );
        Object.assign(form, defaultQuery);
        this.initDefaultQueryId = setTimeout(resolve(form));
      });
    },
    handleSortChange({ prop, order }) {
      setDefaultSort({ prop, order });
      this.tableSearch();
    }
  },
  created() {
    this.$store.commit('dataAnalysis/taskOverdue/SET_SELECTED_SIZE', 0);
  },
  destroyed() {
    clearTimeout(this.createTableId);
    clearTimeout(this.initDefaultQueryId);
    this.CLEAR_QUERY_COUNT_TIMER();
  }
};
</script>
<style scoped lang="scss">
@import '~@/styles/mixin';

.task-list__actions {
  @include flex_jc_ai;
}
</style>
